import { render, staticRenderFns } from "./CriarDiretorioDialog.vue?vue&type=template&id=0a706544&"
import script from "./CriarDiretorioDialog.vue?vue&type=script&lang=js&"
export * from "./CriarDiretorioDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports